import { Video, Camera, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

const resolveThumbnail = (url) => {
    if (!url) return "";
    const iframeMatch = url.match(/iframe\.videodelivery\.net\/([a-f0-9]+)/i);
    if (iframeMatch) return `https://videodelivery.net/${iframeMatch[1]}/thumbnails/thumbnail.jpg`;
    return url;
};

const ContentList = ({ items, onSelect }) => {
    const { t } = useTranslation();
    return (
        <div className="mt-8 space-y-4">
            {items.map((item) => (
                <button
                    key={item.id}
                    type="button"
                    onClick={() => onSelect(item)}
                    className="flex w-full items-center gap-4 rounded-xl border border-slate-200 bg-white px-4 py-4 text-left shadow-[0_10px_20px_rgba(15,23,42,0.06)] transition hover:-translate-y-0.5 hover:shadow-[0_18px_30px_rgba(15,23,42,0.08)] sm:px-6 sm:py-5 focus:outline-none"
                >
                    <div className="flex h-20 w-20 flex-shrink-0 items-center justify-center overflow-hidden rounded-lg bg-slate-100">
                        <img src={resolveThumbnail(item.thumbnail)} alt="" className="max-h-full max-w-full object-contain" />
                    </div>
                    <div>
                        <p className="text-sm font-semibold text-slate-900">{item.title}</p>
                        <p className="mt-1 text-xs text-slate-500">{item.date ? `${t("MY_CONTENT_POSTED_ON")} ${item.date}` : ""}</p>
                        <span className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-primary underline underline-offset-4">
                            {t("MY_CONTENT_VIEW_CONTENT")}
                            <ArrowRight className="h-3 w-3" />
                        </span>
                    </div>
                    <div className="ml-auto flex-shrink-0">
                        {item.type === "Video"
                            ? <Video className="h-7 w-7 text-slate-400" />
                            : <Camera className="h-7 w-7 text-slate-400" />
                        }
                    </div>
                </button>
            ))}
        </div>
    );
};

export default ContentList;
